/**
 * Amounts that qualify for shop free-shipping threshold.
 *
 * Honors:
 *  - Shipping v2 product flag `countsTowardFreeShipping = false` (top-level on Product / cart line),
 *  - Legacy donation flag `pricingConfig.countTowardFreeShipping = false` mirrored as `item.countTowardFreeShipping`.
 *
 * Backend will recompute authoritatively in `quoteOrderShipping`; the frontend value is only used
 * for the cart UI promo + slide-out estimate so customers don't see false "you got free shipping" hints.
 */

export function lineCountsTowardFreeShipping(item) {
  if (!item) return false;
  if (item.countsTowardFreeShipping === false) return false; // Shipping v2 — explicit top-level opt-out
  const isDonation = item.type === 'donation' || item.productType === 'donation';
  // Legacy donation field name (pricingConfig.countTowardFreeShipping) — kept for back-compat.
  if (isDonation && item.countTowardFreeShipping === false) return false;
  return true;
}

/** Sum(price * qty) for lines that count toward the free-shipping floor */
export function getSubtotalForFreeShippingEligible(cartItems) {
  if (!Array.isArray(cartItems)) return 0;
  return cartItems.reduce((sum, item) => {
    if (!lineCountsTowardFreeShipping(item)) return sum;
    const qty = item.quantity ?? 1;
    const unit = typeof item.price === 'number' ? item.price : parseFloat(item.price || 0);
    if (!Number.isFinite(unit)) return sum;
    return sum + unit * qty;
  }, 0);
}
